import { f as fetchConfig } from "@theme/utils";
class ProductForm extends window.HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.querySelector('[name="id"]').disabled = false;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');
    this.quantityInput = this.querySelector('input[name="quantity"]');
    this.decreaseButton = this.querySelector('button[name="minus"]');
    this.increaseButton = this.querySelector('button[name="plus"]');
    this.goToCart = this.closest(".c-product-card") === null && this.closest(".c-highlighted-product") === null;
    if (this.quantityInput && this.decreaseButton && this.increaseButton) {
      this.decreaseButton.addEventListener("click", this.decreaseQuantity.bind(this));
      this.increaseButton.addEventListener("click", this.increaseQuantity.bind(this));
      this.quantityInput.addEventListener("change", this.validateQuantity.bind(this));
      this.updateQuantityButtons();
    }
  }
  decreaseQuantity() {
    const currentValue = parseInt(this.quantityInput.value);
    const minValue = parseInt(this.quantityInput.getAttribute("min")) || 1;
    if (currentValue > minValue) {
      this.quantityInput.value = currentValue - 1;
      this.updateQuantityButtons();
    }
  }
  increaseQuantity() {
    const currentValue = parseInt(this.quantityInput.value);
    const maxValue = parseInt(this.quantityInput.getAttribute("max"));
    if (!maxValue || currentValue < maxValue) {
      this.quantityInput.value = currentValue + 1;
      this.updateQuantityButtons();
    }
  }
  validateQuantity() {
    const currentValue = parseInt(this.quantityInput.value);
    const minValue = parseInt(this.quantityInput.getAttribute("min")) || 1;
    const maxValue = parseInt(this.quantityInput.getAttribute("max"));
    if (isNaN(currentValue) || currentValue < minValue) {
      this.quantityInput.value = minValue;
    } else if (maxValue && currentValue > maxValue) {
      this.quantityInput.value = maxValue;
    }
    this.updateQuantityButtons();
  }
  updateQuantityButtons() {
    const currentValue = parseInt(this.quantityInput.value);
    const minValue = parseInt(this.quantityInput.getAttribute("min")) || 1;
    const maxValue = parseInt(this.quantityInput.getAttribute("max"));
    if (currentValue <= minValue) {
      this.decreaseButton.classList.add("is-disabled");
    } else {
      this.decreaseButton.classList.remove("is-disabled");
    }
    if (maxValue && currentValue >= maxValue) {
      this.increaseButton.classList.add("is-disabled");
    } else {
      this.increaseButton.classList.remove("is-disabled");
    }
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === true) return;
    this.handleErrorMessage();
    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new window.FormData(this.form);
    config.body = formData;
    fetch(`${window.routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        this.submitButton.setAttribute("aria-disabled", true);
        this.error = true;
        return;
      }
      this.error = false;
      if (this.goToCart) {
        window.location = window.routes.cart_url;
      } else {
        this.updateCartIconBubble();
      }
    }).catch((e) => {
      console.error(e);
    }).finally(() => {
      this.submitButton.classList.remove("loading");
      if (!this.error) this.submitButton.removeAttribute("aria-disabled");
    });
  }
  updateCartIconBubble() {
    fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`).then((response) => response.text()).then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartIconBubble = doc.querySelector(".shopify-section");
      const cartIconBubbleElement = document.getElementById("cart-icon-bubble");
      if (cartIconBubbleElement && newCartIconBubble) {
        cartIconBubbleElement.innerHTML = newCartIconBubble.innerHTML;
      }
    }).catch((e) => {
      console.error("Failed to update cart icon bubble:", e);
    });
  }
  handleErrorMessage(errorMessage = false) {
    this.errorMessage = this.errorMessage || this.querySelector("[data-error-message]");
    this.errorMessage.toggleAttribute("hidden", !errorMessage);
    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}
window.customElements.define("product-form", ProductForm);
